import React, {
    useEffect,
    useState
} from 'react';
import { withRouter } from 'react-router-dom';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import {
    Loader,
} from '@jutro/components';
import { PolicyService } from 'gw-capability-policy';
import { RenewalService } from 'gw-capability-renewal';
import { SgPoliciesSummary, SgRenewalProposalsSummary, CepConstants } from 'saga-cep-specific-components';
import { publish } from '@jutro/events';
import {
    ADOBE_TOPICS, SgSessionStorageService, useSgTrackPageName
} from 'saga-modules';
import CommonConstants from 'sg-common-constants';
import SgCepSideMenu from 'sg-cep-side-menu';
import styles from './LandingPage.module.scss';
import metadata from './LandingPage.metadata.json5';
import './LandingPage.messages';

function LandingPage() {
    const [isLoading, setLoadingState] = useState(true);
    const [policies, setPolicies] = useState({});
    const [renewals, setRenewals] = useState({});

    useSgTrackPageName(CepConstants.PAGE_NAMES.MANAGE_POLICY);

    useEffect(() => {
        const policiesPromise = PolicyService.getAccountPolicySummaries();
        const renewalsPromise = RenewalService.getRenewalProposalSummaries();
        SgSessionStorageService.removeItem(SgSessionStorageService.KEY.MODEL);

        Promise.all([policiesPromise, renewalsPromise]).then((results) => {
            setPolicies(results[0]);
            setRenewals(results[1]);
            publish(ADOBE_TOPICS.SELF_SERVE_PRODUCTS, {
                policyArray: results[0],
                renewalArray: results[1]
            });
            setLoadingState(false);
        });
    }, []);

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }
    const override = {
        cepPoliciesSummary: {
            policies: policies
        },
        cepRenewalsSummary: {
            renewals: renewals
        },
        linkToMySaga: {
            href: CommonConstants.SAGA_LINKS.MYSAGA_URL
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {},
        resolveComponentMap: {
            SgPoliciesSummary: SgPoliciesSummary,
            SgRenewalProposalsSummary: SgRenewalProposalsSummary,
            SgCepSideMenu
        }
    };

    return renderContentFromMetadata(metadata.pageContent, override, resolvers);
}

export default withRouter(LandingPage);
